import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="relative overflow-hidden bg-forest py-20 md:py-28" data-id="element-159">
      {/* Subtle background image */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/jDUzFyLpZQKXA8WeUmY6hg/heylloyd-image-1779938771738.png')",
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden="true" data-id="element-160" />

      <div className="relative mx-auto max-w-3xl px-6" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="rounded-2xl border-2 border-amber bg-cream p-8 shadow-premium md:p-14" data-id="element-162">
          <div className="mb-8 text-center" data-id="element-163">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-amber" data-id="element-164">
              Acceso inmediato
            </p>
            <h2 className="font-serif text-3xl leading-tight text-charcoal md:text-5xl" data-id="element-165">
              Recupera el control de tu cuerpo hoy mismo.
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-charcoal-light md:text-lg" data-id="element-166">
              No permitas que la inflamación se convierta en una enfermedad
              crónica. Obtén el acceso inmediato a{' '}
              <em className="font-serif" data-id="element-167">"The Inflammatix Reset"</em> por un
              pago único.
            </p>
          </div>

          <div className="mb-8 rounded-xl bg-cream-dark p-6 text-center md:p-8" data-id="element-168">
            <p className="mb-2 text-xs font-medium uppercase tracking-[0.18em] text-charcoal-light" data-id="element-169">
              Precio especial de lanzamiento
            </p>
            <div className="mb-2 flex items-baseline justify-center gap-3" data-id="element-170">
              <span className="font-serif text-2xl text-charcoal-light line-through decoration-amber/60 decoration-2" data-id="element-171">
                $27
              </span>
              <span className="rounded-full bg-amber px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-cream" data-id="element-172">
                -76%
              </span>
            </div>
            <div className="mb-2 flex items-baseline justify-center gap-2" data-id="element-173">
              <span className="font-serif text-6xl font-medium text-charcoal md:text-7xl" data-id="element-174">
                $6.39
              </span>
              <span className="font-serif text-2xl text-charcoal-light" data-id="element-175">
                USD
              </span>
            </div>
            <p className="text-sm text-charcoal-light" data-id="element-176">
              Un solo pago. Sin suscripciones.
            </p>
          </div>

          <ul className="mb-10 space-y-3" data-id="element-177">
            {['Protocolo paso a paso de 72 horas', 'Listas de alimentos "Agua" vs. "Gasolina"', 'Sistema de drenaje linfático de 2 minutos', 'Guía de hacks de sueño y rutina post-72h'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal" data-id="element-178">
                <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-amber/15" data-id="element-179">
                  <CheckIcon className="h-3 w-3 text-amber-dark" strokeWidth={3} data-id="element-180" />
                </span>
                <span className="text-base" data-id="element-181">{item}</span>
              </li>)}
          </ul>

          <a href="https://www.nuevoeje.com/cart/55161732006179:1" className="group block w-full rounded-full bg-amber px-8 py-5 text-center font-medium uppercase tracking-wider text-cream shadow-premium transition-all hover:bg-amber-dark hover:shadow-lg active:scale-[0.99]" data-id="element-182">
            ¡Quiero desinflamarme ahora!
          </a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-charcoal-light" data-id="element-183">
            <LockIcon className="h-4 w-4" data-id="element-184" />
            <span data-id="element-185">Acceso inmediato tras la compra · Pago 100% seguro</span>
          </div>
        </motion.div>
      </div>
    </section>;
}